import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  idCompletionSubmitButton: {
    defaultMessage: 'Continue',
    id: 'IdCompletionTemplate.submit',
  },
  decoupledTemplateContinue: {
    defaultMessage: "Yes, I've authenticated",
    id: 'DecoupledTemplate.submit',
  },
});
